<template>
  <div style="width: 96%;margin: auto; padding: 10px;">
    <div>
      <el-form ref="form" :inline="true" :model="form" label-width="80px">
        <el-form-item label="门店">
          <el-select filterable multiple v-model="form.storeId" placeholder="请选择门店">
            <el-option
                v-for="item in optionStore"
                :key="item.shopId"
                :label="item.shopName"
                :value="item.shopId">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item>
          <el-button style="margin-left: 10px;" type="primary" @click="search">查询</el-button>
          <el-button type="reset" @click="reset">重置</el-button>
          <el-button type="warning" @click="back">返回</el-button>
        </el-form-item>
      </el-form>
    </div>
    <div style="width: 96%;margin: auto;padding: 10px;color: red;">
      预警周期：{{ startDate }} - {{ endDate }}
    </div>
    <div style="width: 96%;margin: auto;padding: 10px;color: red;">
      规则说明：【（本期/同期-1）-（月度指标/同期全月-1）】<-5%（跨越星期算作周一所在月份）
    </div>
    <div style="margin: 30px auto;padding: 10px;margin-left: 30px;">
      <span class="text-gradient1">门店客流</span>
      <div class="mt-1">
        <el-table
            :data="tableStoreData"
            stripe
            style="width: 100%">
          <el-table-column
              prop="deptName"
              label="门店"
              width="180">
          </el-table-column>
          <el-table-column
              prop="passengerflow"
              label="客流"
              width="180">
          </el-table-column>
          <el-table-column
              label="同比"
              width="180">
            <template slot-scope="scope">
              <i v-if="scope.row.fh" :class="scope.row.fh == 1 ? 'el-icon-caret-top' : 'el-icon-caret-bottom'"
                 :style="scope.row.fh == 1 ? 'color: green' : 'color: red'"></i>{{ scope.row.tb }}%
            </template>
          </el-table-column>
          <el-table-column
              label="标准值差异">
            <template slot-scope="scope">
              <span v-if="scope.row.fh1 && scope.row.fh1 == 2">-</span>{{ scope.row.ysjd }}
            </template>
          </el-table-column>
          <el-table-column
              v-if="item.isDouble == 1"
              label="预算周期">
            <template slot-scope="scope">
              {{ scope.row.startdate }} - {{ scope.row.enddate }}
            </template>
          </el-table-column>
        </el-table>
      </div>
    </div>
  </div>

</template>

<script>
import StoreApi from "../../api/pd/common/StoreApi";
import AlarmOrderApi from "../../api/alarm/order/AlarmOrderApi";
import { default as commonIn } from '@/util/common'
export default {
  name: "passengerFlowDetail",
  props: {
    item: {
      type: Object,
      default: null
    },
    storeId: {
      type: String,
      default: ""
    },
    role: {
      type: Number
    },
    turnType: {
      type: Number,
      default: 0
    }
  },
  data() {
    return {
      optionStore: [],
      form: {
        storeId: []
      },
      tableStoreData: [],
      startDate: '',
      endDate: ''
    }
  },
  created() {

  },
  mounted() {
    this.getStore()
    let createDate = commonIn.timeFormatSeconds(this.item.createDate)
    let taskType  = this.item.isDouble == 1 ? 3 : this.item.taskType
    let dateArr = commonIn.getAlarmCycle({date: createDate, type: taskType})
    this.startDate = dateArr[0]
    this.endDate = dateArr[1]

    if (this.item.taskType == 2) {
      createDate = ''
    }

    let params = {positionDeptId: this.item.positionDeptId, role: this.role}
    if (this.item.isDouble != 1) {
      params.createDate = createDate
    } else {
      params.startTime = this.startDate + ' 00:00:00'
      params.endTime = this.endDate + ' 00:00:00'
    }
    if (this.storeId) {
      this.form.storeId = ['60' + this.storeId]
      params.storeId = this.storeId
    }
    if (this.item.taskType == 2 && this.item.isDouble != 1) {
      params.createDate = ''
      params.taskType = 2
    }
    if (this.role == 2 && this.item.taskType == 2) {
      params.deptId = this.item.deptId
    }
    this.getRateDetail(params)
  },
  methods: {
    // 获取客流详情
    getRateDetail(params) {
      console.log(params)
      let that = this

      AlarmOrderApi.getPassengerFlowDetail(params).then(res => {
        console.log(res.data)
        res = res.data
        if (res.code == 200) {
          let dataIn = res.data;
          if (dataIn.length > 0) {
            dataIn.map(item => {
              item.startdate = commonIn.timeFormatSeconds(item.startdate)
              item.startdate = (item.startdate).split(" ")[0]
              item.enddate = commonIn.timeFormatSeconds(item.enddate)
              item.enddate = (item.enddate).split(" ")[0]
              if (item.passengerflowSameperiod != null) {
                item.tb = parseFloat(item.passengerflow) / parseFloat(item.passengerflowSameperiod) * 100 - 100;
                item.fh = 1
                if (item.tb < 0) {
                  item.tb = (0 - item.tb).toFixed(2)
                  item.fh = 2
                } else {
                  item.tb = (item.tb).toFixed(2)
                  if (item.tb > 100) {
                    item.fh = 2
                  }
                }

              } else {
                item.tb = 0;
              }

              if (item.targetValue != null) {
                let target = parseFloat(item.targetValue)
                item.fh1 = 1
                if (target < 0) {
                  target = 0 - target
                  item.fh1 = 2
                }
                console.log(target)
                item.ysjd = (target * 100).toFixed(1)
                item.ysjd = item.ysjd + '%'
              }
              console.log(item)
            })
            that.tableStoreData = dataIn
          }
        }
      })
    },
    // 获取门店列表
    getStore() {
      let that = this
      StoreApi.queryStoreList().then(res => {
        console.log(res)
        res = res.data
        if (res.code == 200) {
          that.optionStore = res.data.shopPriviledges
          console.log(that.optionStore)
        } else {
          that.$message.error(res.msg)
        }
      }).catch(error => {
        console.log(error)
        that.$message.warning('系统错误！请稍后尝试')
      })
    },
    search() {
      let shopIds = this.form.storeId
      console.log(shopIds)

      // let shopId = shopId.slice(-2)
      let arr = []
      shopIds.map(item => {
        if (item.length >= 4) {
          item = item.slice(-2)
        }
      
        item = item.length == 1 ? '0' + item : item
        arr.push(item)
      })
      // let shopIdIn = shopId.length == 1 ? '0' + shopId : shopId
      let createDate = commonIn.timeFormatSeconds(this.item.createDate)
      let params = {
        storeIds: arr,
        createDate: createDate
      }
      console.log(params)
      if (this.item.taskType == 2) {
        params.createDate = ''
        params.taskType = 2
      }
      this.getRateDetail(params)
    },
    reset() {
      this.form.resetFields()
    },
    back() {
      if (this.turnType == 1) {
        this.$emit("addCallbackTask")
      } else {
        this.$emit("back")
      }
    }
  }
}
</script>

<style scoped>
  .text-gradient1 {
    background-image: linear-gradient(to right, #ffd666, #ad6800);
    -webkit-background-clip: text;
    color: transparent;
    font-weight: 700;
    font-size: 17px;
  }
</style>